module.exports = __webpack_public_path__ + "img/nogomet.b4c743bc.jpg";